import clsx from 'clsx';
import React, { forwardRef } from 'react';
import './Menu.css';
export const MenuItem = forwardRef((props, ref) => {
    const { children, elementType: Element = 'a', selected, className, ...rest } = props;
    return (React.createElement("li", { className: clsx('mollie-ui-menu-item', {
            'mollie-ui-menu-item--selected': selected,
        }) },
        React.createElement(Element, { ...rest, className: clsx('mollie-ui-menu-link', {
                'mollie-ui-menu-link--selected': selected,
            }, className), ref: ref, "aria-current": selected ? 'true' : undefined }, children)));
});
MenuItem.displayName = 'Menu.Item';
//# sourceMappingURL=MenuItem.js.map